import 'ol/ol.css';
import ImageWMS from 'ol/source/ImageWMS';
import GeoJSON from 'ol/format/GeoJSON';
import {bbox as bboxStrategy, tile} from 'ol/loadingstrategy';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import {Image as ImageLayer, Tile as TileLayer} from 'ol/layer';
import LayerSwitcher from 'ol-layerswitcher';
import { BaseLayerOptions, GroupLayerOptions } from 'ol-layerswitcher';
import {ScaleLine, defaults as defaultControls} from 'ol/control';

import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';

import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

import {fromLonLat} from 'ol/proj';
import 'ol-layerswitcher/src/ol-layerswitcher.css';

import borders from "./vector/Граница.json";
import blocks from "./vector/Кадастровый квартал.json";
import zu from "./vector/Земельный участок.json";

import oks from "./vector/ОКС.json";
import zouit from "./vector/ЗОУИТ.json";
import dorogi from "./vector/дороги.json";

import companies from "./vector/Управляющие компании.json"
import buildings from "./vector/Здание.json"
import buildingNumbers from "./vector/Номер дома.json"
import green from "./vector/Зеленая_зона.json"
import parking from "./vector/Парковки.json"
import sport from "./vector/Спортивные площадки.json"
import childSport from "./vector/Детские_площадки.json"
import garbage from "./vector/Площадка_для_сбора_мусора.json"
import roads from "./vector/Пешеходные_дорожки.json"
import carRoads from "./vector/Дороги_проезды.json"
import streets from "./vector/Улицы.json"
import territory from "./vector/Территория мкд.json"

import XYZ from 'ol/source/XYZ';
import TileImage from 'ol/source/TileImage';

var hostURL = "109.248.57.203:8080"

var vectorSourceTerr = new VectorSource({
	features: new GeoJSON().readFeatures(territory),
});

var vectorSourceStreets = new VectorSource({
	features: new GeoJSON().readFeatures(streets),
});

var style1 = new Style({
  stroke: new Stroke({
      color: 'rgba(255, 0, 0, 0)',
      width: 1,
    }),
  text: new Text({
    font: 'bold 14px "Times New Roman", "Arial Unicode MS", "sans-serif"',
    placement: 'line',
    
    fill: new Fill({
      color: 'white',
    }),
    //backgroundFill:  new Fill({
      //color: 'white',
    //}),
  }),
});

var vectorStreets = new VectorLayer({
	minZoom: 13,
  source: vectorSourceStreets,
  style:  function (feature) {
        style1.getText().setText(feature.get('Наименование'));
        return style1;
      },
});

var vectorSourceBuildingNumbers = new VectorSource({
	features: new GeoJSON().readFeatures(buildingNumbers),
});

var style = new Style({

  text: new Text({
    font: 'bold 12px "Times New Roman", "Arial Unicode MS", "sans-serif"',
    placement: 'point',
    
    fill: new Fill({
      color: 'white',
    }),
  }),
});

    
var vectorBuildingNumbers = new VectorLayer({
	minZoom: 13,
  source: vectorSourceBuildingNumbers,
  style:   function (feature) {
        style.getText().setText(feature.get('Наименование'));
        return style;
      },
}); 

var vectorSourceCarRoads = new VectorSource({
	features: new GeoJSON().readFeatures(carRoads),
});

var vectorCarRoads = new VectorLayer({
  title:'Дороги, проезды',
  source: vectorSourceCarRoads,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(128, 128, 128, 0.8)',
      width: 1,
    }),
	}),
}); 

var vectorSourceRoads = new VectorSource({
	features: new GeoJSON().readFeatures(roads),
});

var vectorRoads = new VectorLayer({
  title:'Пешеходные дорожки',
  source: vectorSourceRoads,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(128, 128, 128, 0.8)',
      width: 1,
    }),
	}),
}); 

var vectorSourceGarbage = new VectorSource({
	features: new GeoJSON().readFeatures(garbage),
});

var vectorGarbage = new VectorLayer({
  title:'Площадки для сбора мусора',
  source: vectorSourceGarbage,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(255, 255, 255, 0.8)',
      width: 1,
    }),
	}),
}); 

var vectorSourceChildSport = new VectorSource({
	features: new GeoJSON().readFeatures(childSport),
});

var vectorChildSport = new VectorLayer({
  title:'Детские площадки',
  source: vectorSourceChildSport,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(255, 255, 255, 0.8)',
      width: 1,
    }),
	}),
}); 

var vectorSourceSport = new VectorSource({
	features: new GeoJSON().readFeatures(sport),
});

var vectorSport = new VectorLayer({
  title:'Спортивные площадки',
  source: vectorSourceSport,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(255, 255, 255, 0.8)',
      width: 1,
    }),

	}),
}); 

var vectorSourceParking = new VectorSource({
	features: new GeoJSON().readFeatures(parking),
});

var vectorParking = new VectorLayer({
  title:'Парковки',
  source: vectorSourceParking,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(128, 128, 128, 0.8)',
      width: 1,
    }),
	}),
}); 

var vectorSourceGreen = new VectorSource({
	features: new GeoJSON().readFeatures(green),
});

var vectorGreen = new VectorLayer({
  title:'Зеленая зона',
  source: vectorSourceGreen,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(96, 255, 96, 0.8)',
      width: 1,
    }),
	}),
}); 

// Здания
var vectorSourceBuildings = new VectorSource({
	features: new GeoJSON().readFeatures(buildings),
}); 

var vectorBuildings = new VectorLayer({
  title:'Здания',
  source: vectorSourceBuildings,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(255, 128, 0, 0.8)',
      width: 2,
    }),
	fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});   

// Автомобильные дороги
var vectorSourceDorogi = new VectorSource({
	features: new GeoJSON().readFeatures(dorogi),
}); 

var vectorDorogi = new VectorLayer({
  title:'Автомобильные дороги',
  visible: false,
  source: vectorSourceDorogi,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(247, 242, 53, 0.8)',
      width: 2,
    }),
	fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});  

function removeOptions(selectElement) {
   var i, L = selectElement.options.length - 1;
   for(i = L; i >= 0; i--) {
      selectElement.remove(i);
   }
}

const features = vectorBuildings.getSource().getFeatures();
const featureCollection = new ol.Collection(features);

const knInput = document.querySelector("[kn-search]");
var knList = document.getElementById('kn2');

knInput.addEventListener('input', (e) => {
	
	const kn = e.target.value;
	if (!isNaN(kn.charAt(0))) {
		searchFeatures("Кад_Номер", kn);
	} else {
		searchFeatures("Адрес", kn);
	}
})

function searchFeatures(propertyName, propertyValue) {
	removeOptions(knList)
	var matchingFeatures = [];
	features.forEach(function(feature) {
		var value = feature.get(propertyName)
		if (value && value.toString().toLowerCase().indexOf(propertyValue.toLowerCase()) !== -1) {
			matchingFeatures.push(feature);
		}
	});
	
	matchingFeatures.forEach(function(feature) {
		var option = document.createElement('option');
		option.value = feature.get(propertyName);
		option.text = feature.get(propertyName);
		knList.appendChild(option);
	});
	//console.log(knList.options.length);
	knList.addEventListener('click', function(e) {
		var count = knList.options.length;
		if(typeof(count) === "undefined" || count < 2)
		{
			select.getFeatures().clear();
			var featureKN = knList.value;
			var featureFound = null;
			features.forEach(function(feature) {
				if (feature.get(propertyName) === featureKN) {
					featureFound = feature;
				}		
				});
			if (featureFound) {
				var extent = featureFound.getGeometry().getExtent();
				var geom = ol.geom.Polygon.fromExtent(extent);
				var padding = [100, 100, 100, 100];
				geom.scale(3.5);
				map.getView().fit(geom,{duration: 1000},{padding: padding});
				select.getFeatures().push(featureFound);
			}
		}
	});
	knList.addEventListener('change', function(e) {
	select.getFeatures().clear();
	var featureKN = knList.value;
	var featureFound = null;
	features.forEach(function(feature) {
		if (feature.get(propertyName) === featureKN) {
			featureFound = feature;
		}		
		});
	if (featureFound) {
		var extent = featureFound.getGeometry().getExtent();
		var geom = ol.geom.Polygon.fromExtent(extent);
		
		geom.scale(1.8);
		map.getView().fit(geom,{duration: 1000});
		select.getFeatures().push(featureFound);
	}
	});
}
        
var vectorSourceCompanies = new VectorSource({
	features: new GeoJSON().readFeatures(companies),
});    

var vectorTerritory = new VectorLayer({
  title:'Территория МКД',
  source: vectorSourceTerr,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(160, 160, 255, 0.8)',
      width: 2,
    }),
  fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});

var vectorSourceB = new VectorSource({
	features: new GeoJSON().readFeatures(borders),
});

var vectorB = new VectorLayer({
	title:'Граница',
	visible: false,
	source: vectorSourceB,
	style: new Style({
	stroke: new Stroke({
      color: 'rgba(128, 0, 128, 0.7)',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});

var vectorSourceZouit = new VectorSource({
	features: new GeoJSON().readFeatures(zouit),
});

var vectorZouit = new VectorLayer({
	title:'ЗОУИТ',
	visible: false,
	source: vectorSourceZouit,
	style: new Style({
	stroke: new Stroke({
      color: 'rgba(150, 215, 242, 0.7)',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});

var vectorSourceKK = new VectorSource({
  features: new GeoJSON().readFeatures(blocks),
});

var vectorKK = new VectorLayer({
	title:'Кадастровый квартал',
	visible: false,
	source: vectorSourceKK,
	style: new Style({
	stroke: new Stroke({
      color: 'rgba(200, 0, 0, 0.7)',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});

var vectorSourceZU = new VectorSource({
	features: new GeoJSON().readFeatures(zu),
});

var vectorZU = new VectorLayer({
  title:'Земельный Участок',
  source: vectorSourceZU,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(255, 0, 0, 0.8)',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 0, 0)',
    }),
    }),
});

var vectorSourceOKS = new VectorSource({
	features: new GeoJSON().readFeatures(oks),
});

var vectorOKS = new VectorLayer({
	title:'ОКС',
  source: vectorSourceOKS,
  style: new Style({
  stroke: new Stroke({
      color: 'rgba(145, 27, 27, 0.7)',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0)',
    }),
	}),
});

var photoplans = new TileLayer({
	title:"Фотопланы 2021",
	extent: [3394630.21246605413, 8371944.688001309521, 3398670.403509617783, 8383450.814205427654],
  source: new OSM({
	//projection: 'EPSG:4326',
	//tileUrlFunction : tileUrlFunction2,
    url: 'http://' + hostURL + '/raster/2021/{z}/{x}/{-y}.png',
    opaque: false,
    maxZoom: 20,

  }),
  visible: false
});      

var photoplans2 = new TileLayer({
	title:"Фотопланы 2023",
	extent: [3394630.21246605413, 8371944.688001309521, 3398670.403509617783, 8383450.814205427654],
  source: new OSM({
	//projection: 'EPSG:4326',
	//tileUrlFunction : tileUrlFunction2,
    url: 'http://' + hostURL + '/raster/2023/{z}/{x}/{-y}.png',
    opaque: false,
    maxZoom: 20,

  }),
  visible: true	
});  

const osm = new TileLayer({
				source: new OSM(),
				})

var SectorJKH = new ol.layer.Group({
  title: 'Сектор ЖКХ:',
  fold: 'open',
  
            // Setting combine to true causes sub-layers to be hidden
            // in the layerswitcher, only the parent is shown
  layers: [vectorChildSport, vectorSport, vectorGarbage, vectorGreen, vectorParking, vectorRoads, vectorCarRoads, vectorBuildings, ]
});	

var signs = new ol.layer.Group({
	layers: [vectorStreets, vectorBuildingNumbers]
});

var EGRN = new ol.layer.Group({
	title: 'Сведения ЕГРН:',
	fold: 'open',
	
	layers: [vectorKK,vectorZouit,vectorB,vectorOKS,vectorZU, ]
});

var layers = [osm, photoplans, photoplans2, EGRN, SectorJKH, vectorDorogi, vectorTerritory, signs];
  
const zanevkaLonLat = [30.5131, 59.9024];
const zanevkaWebMercator = fromLonLat(zanevkaLonLat);  

var view =  new View({
	  projection: 'EPSG:3857',
	  //displayProjection: new OpenLayers.Projection("EPSG:4326"),
    center: zanevkaWebMercator,
    zoom: 13
  });

var map = new Map({
  target: 'map',
  layers: layers,
  //controls: defaultControls().extend([
    //new ScaleLine({
      //units: 'degrees',
    //}) ]),
  view: view
});

var layerSwitcher = new LayerSwitcher({
    activationMode: 'click',
    startActive: true,
   // groupSelectStyle: 'children' // Can be 'children' [default], 'group' or 'none'
  });
map.addControl(layerSwitcher);

function showInfo(event) {
	showInfoBuildings(event)
	showInfoTerr(event)
	showInfoOKS(event)
	showInfoZU(event)
	showInfoDorogi(event)
	showInfoBorder(event)
	showInfoKK(event)
	showInfoZouit(event) 
}

map.on('singleclick', showInfo);

//Территория
function showInfoTerr(event) {
var info = document.getElementById('home2');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorTerritory;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}
info.innerHTML = '<li><b>Территория</b>:';

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
var str = '<ul>';
var companyStr = '';
for (let [key, value] of Object.entries(properties)) {
	if (key == "Карточка") {
		if (value.length > 0) {
			companyStr = '<a href="' + 'http://' + hostURL + '/pdf/companies/' + value + '" target="_blank">'
		}
	}
}
for (let [key, value] of Object.entries(properties)) {
	if (key == "Отчёты") {
		if (value.length > 0) {
			str += '<a href="' + 'http://' + hostURL + '/pdf/layouts/' + value + '" target="_blank">' + 'Отчёт' + '</a> \n' 
		}
	}
	else if (key != "Карточка"){
		if (key == "Управляющая_Компания") {
			str += '<li>' + key + ' : ' + companyStr + value + '</a> \n' 
		}
		else {
		str += '<li>' + key + ' : ' + value + ' </li> \n';
	}
	}
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// Здание
function showInfoBuildings(event) {
var info = document.getElementById('home1');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorBuildings;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}
info.innerHTML = '<li><b>Здание</b>:';

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.Площадь;
delete properties.Примечание;
delete properties.Назначение;
delete properties.Номер;
var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	if (key == "pdf_link") {
		if (value != "РОЖФ КН.pdf"){
			str += '<a href="' + 'http://' + hostURL + '/pdf/buildings/' + value + '" target="_blank">' + 'Документ' + '</a> \n' 
		}
	}
	else {
		str += '<li>' + key + ' : ' + value + ' </li> \n';
	}
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// Земельный участок
function showInfoZU(event) {
var info = document.getElementById('home4');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorZU;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}
if (features.length > 1) {
info.innerHTML = '<li><b>Земельные участки</b>:';
}
else {
info.innerHTML = '<li><b>Земельный участок</b>:';
}

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.MI_STYLE;
delete properties.Примечание;
delete properties.Статус;
delete properties.Квартал;
delete properties.Адрес;
delete properties.КН_ОКСнаЗУ;
delete properties.Право;
delete properties.Правообладатель;
delete properties.КатегорияЗемель;

if (properties.КН_ОКСнаЗУ == null) {
	delete properties.КН_ОКСнаЗУ;
}
if (properties.Право == null) {
	delete properties.Право;
}
if (properties.Правообладатель  == null) {
	delete properties.Правообладатель;
}
var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	str += '<li>' + key + ' : ' + value + ' </li> \n';
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// ОКС
function showInfoOKS(event) {
var info = document.getElementById('home3');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorOKS;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}
if (features.length > 1) {
info.innerHTML = '<li><b>ОКСы</b>:';
}
else {
info.innerHTML = '<li><b>ОКС</b>:';
}
for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.MI_STYLE;
delete properties.Примечание;
delete properties.Право;
delete properties.Правообладатель;
delete properties.Адрес;
delete properties.Вид_Объекта_Недв;
delete properties.Квартал;
delete properties.Назначение;

var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	str += '<li>' + key + ' : ' + value + ' </li> \n';
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// Граница
function showInfoBorder(event) {
var info = document.getElementById('home5');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorB;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}

info.innerHTML = '<li><b>Граница</b>:';

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.MI_STYLE;
delete properties.Примечание;
delete properties.Основание;
delete properties.Дата_внесения;

var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	str += '<li>' + key + ' : ' + value + ' </li> \n';
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// Кадастровый квартал
function showInfoKK(event) {
var info = document.getElementById('home6');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorKK;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}

info.innerHTML = '<li><b>Кадастровый квартал</b>:';

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.MI_STYLE;
delete properties.Примечание;
delete properties.Основание;
delete properties.Дата_внесения;

var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	str += '<li>' + key + ' : ' + value + ' </li> \n';
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// ЗОУИТ
function showInfoZouit(event) {
var info = document.getElementById('home4.5');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorZouit;
},
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}

info.innerHTML = '<li><b>ЗОУИТ</b>:';

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.MI_STYLE;
delete properties.Примечание;
delete properties.Основание;
delete properties.Дата_внесения;
delete properties.Вид;

var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	str += '<li>' + key + ' : ' + value + ' </li> \n';
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

// Автомобильные дороги
function showInfoDorogi(event) {
var info = document.getElementById('home4.2');   
var features = map.getFeaturesAtPixel(event.pixel, {
layerFilter: function (layer) {
return layer === vectorDorogi;
},
hitTolerance: 2,
});
if (features.length == 0) {
info.innerText = '';
info.style.opacity = 0;
return;
}

info.innerHTML = '<li><b>Автомобильные дороги</b>:';

for (var i = 0; i < features.length; i++) {
var properties = features[i].getProperties();
delete properties.geometry;
delete properties.MI_STYLE;


var str = '<ul>';
for (let [key, value] of Object.entries(properties)) {
	str += '<li>' + key + ' : ' + value + ' </li> \n';
}
str += '</ul>';
info.innerHTML += str;
info.style.opacity = 1;
}
info.innerHTML += '</li>'
}

var sidebar = new ol.control.Sidebar({ element: 'sidebar', position: 'left' });

map.addControl(sidebar);
 
function open_sidebar(event) {
	sidebar.open('home')
}
map.on('singleclick', open_sidebar)
		
// Control Select 
var highlightStyle = new Style({
  fill: new Fill({
    color: 'rgba(255,255,255,0.35)',
  }),
  stroke: new Stroke({
    color: '#0000FF',
    width: 4,
  }),
  text: new Text({
    font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
    placement: 'point',
    fill: new Fill({
      color: 'black',
    }),
  }),
});

var highlightStyle1 = function (feature) {
        highlightStyle.getText().setText(feature.get('Кад_Номер'));
        return highlightStyle;
      }
      
var select = new ol.interaction.Select({layers:[vectorTerritory, vectorBuildings], style: highlightStyle1, condition: ol.events.condition.singleClick, multi: true,});
map.addInteraction(select);

// Handle the selection event
select.on('select', (e) => {
	  const selectedFeatures = e.target.getFeatures();
      if (selectedFeatures.getLength() > 1) {
        // If there are overlapping polygons, select the smaller one
        const feature1 = selectedFeatures.getArray()[0];
        const feature2 = selectedFeatures.getArray()[1];
        const geom1 = feature1.getGeometry();
        const geom2 = feature2.getGeometry();
        if (geom1.getArea() < geom2.getArea()) {
          selectedFeatures.remove(feature2);
        } else {
          selectedFeatures.remove(feature1);
        }
      }
	});

